export default __webpack_public_path__ + "static/media/file-delete.1c4dad96.svg";